import axios from "axios";

const getCookie = (name) => {
    const cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
        const cookiePair = cookies[i].split("=");
        const cookieName = cookiePair[0];
        const cookieValue = decodeURIComponent(cookiePair[1]);

        if (name.trim() === cookieName.trim()) {
            return cookieValue;
        }
    }

    return localStorage.getItem(name);
};

let fqdnBaseURL = window.location.hostname;
if (
    fqdnBaseURL === undefined ||
    fqdnBaseURL === null ||
    fqdnBaseURL === "localhost" ||
    fqdnBaseURL === "127.0.0.1"
) {
    fqdnBaseURL = process.env.REACT_APP_FQDN_DEFAULT_BASE_URL;
}

const axiosClient = axios.create({
    baseURL: `https://${fqdnBaseURL}/api/v1/my`,
});

axiosClient.interceptors.request.use((config) => {
    const token = getCookie("ACCESS_TOKEN");
    config.headers.Authorization = `Bearer ${token}`;
    config.headers.Accept = "application/json";
    config.headers.ContentType = "application/json";
    return config;
});

axiosClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const { response } = error;
        if (response.status === 401) {
            localStorage.removeItem("ACCESS_TOKEN");
            document.cookie =
                "ACCESS_TOKEN=; SameSite=strict; Max-Age=0; path=/";
            window.location.replace("/auth/sign-in");
        } else if (response.status === 404) {
            //Show not found
        }

        throw error;
    }
);

export default axiosClient;
